import AppNavBarPresentation from 'components/AppNavBar/AppNavBarPresentation'

export default {
  Presentation: AppNavBarPresentation,
}
